import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityTimeline = ({ activities, customerName }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'quotation':
        return 'FileText';
      case 'order':
        return 'ShoppingCart';
      case 'invoice':
        return 'Receipt';
      case 'support':
        return 'Headphones';
      case 'delivery':
        return 'Truck';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'quotation':
        return 'text-primary bg-primary-100';
      case 'order':
        return 'text-success bg-success-100';
      case 'invoice':
        return 'text-warning bg-warning-100';
      case 'support':
        return 'text-info bg-info-100';
      case 'delivery':
        return 'text-purple-600 bg-purple-100';
      default:
        return 'text-text-secondary bg-secondary-100';
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return new Intl.DateTimeFormat('es-ES', {
      day: 'numeric',
      month: 'short'
    }).format(date);
  };

  if (activities.length === 0) {
    return (
      <div className="card">
        <div className="p-4 border-b border-border">
          <h3 className="text-lg font-heading-semibold text-text-primary">
            Cronología de Actividad
          </h3>
          {customerName && (
            <p className="text-sm text-text-secondary mt-1">
              {customerName}
            </p>
          )}
        </div>
        <div className="p-8 text-center">
          <Icon name="Clock" size={48} className="mx-auto text-text-muted mb-4" />
          <h4 className="text-sm font-heading-semibold text-text-secondary mb-2">
            Sin Actividad Reciente
          </h4>
          <p className="text-xs text-text-muted">
            No hay actividades registradas para este cliente
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="p-4 border-b border-border">
        <h3 className="text-lg font-heading-semibold text-text-primary">
          Cronología de Actividad
        </h3>
        {customerName && (
          <p className="text-sm text-text-secondary mt-1">
            {customerName}
          </p>
        )}
        <p className="text-xs text-text-muted mt-1">
          {activities.length} actividad{activities.length !== 1 ? 'es' : ''} reciente{activities.length !== 1 ? 's' : ''}
        </p>
      </div>

      <div className="max-h-96 overflow-y-auto">
        <div className="p-4">
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-6 top-0 bottom-0 w-px bg-border"></div>

            {/* Activities */}
            <div className="space-y-4">
              {activities.map((activity, index) => (
                <div key={activity.id} className="relative flex items-start space-x-4">
                  {/* Timeline dot */}
                  <div className={`relative z-10 flex items-center justify-center w-8 h-8 rounded-full border-2 border-white ${getActivityColor(activity.type)}`}>
                    <Icon name={getActivityIcon(activity.type)} size={14} />
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0 pb-4">
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <h4 className="text-sm font-body-semibold text-text-primary">
                          {activity.title}
                        </h4>
                        <p className="text-xs text-text-secondary mt-1">
                          {activity.description}
                        </p>
                      </div>
                      <div className="ml-2 text-right">
                        <div className="text-xs text-text-muted">
                          {formatDate(activity.date)}
                        </div>
                        <div className="text-xs text-text-muted">
                          {activity.time}
                        </div>
                      </div>
                    </div>

                    {activity.status && (
                      <div className="mt-2">
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-body-medium ${
                          activity.status === 'completed' ? 'bg-success-100 text-success' :
                          activity.status === 'resolved' ? 'bg-info-100 text-info' :
                          activity.status === 'pending'? 'bg-warning-100 text-warning' : 'bg-secondary-100 text-text-secondary'
                        }`}>
                          {activity.status === 'completed' ? 'Completado' :
                           activity.status === 'resolved' ? 'Resuelto' :
                           activity.status === 'pending' ? 'Pendiente' :
                           activity.status}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="p-4 border-t border-border bg-secondary-25">
        <div className="flex items-center justify-between">
          <button className="text-sm text-primary hover:text-primary-600 font-body-medium transition-micro">
            Ver Todo el Historial
          </button>
          <button className="inline-flex items-center text-sm text-text-secondary hover:text-text-primary transition-micro">
            <Icon name="Plus" size={14} className="mr-1" />
            Nueva Actividad
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActivityTimeline;